import { z } from 'zod';

/**
 * How a member's photos are shown to other members.
 *
 * The photo counterpart of the answer visibility engine: the resolver decides
 * *answers*, this decides *photo treatment*, and the media layer renders it
 * (a `blurHash` placeholder versus a real presigned GET, N12). They are two
 * mechanisms because they protect two different things, but the member is shown
 * one "privacy" idea — keep the UX copy aligned (`03-visibility-policy.md`).
 *
 * The **default is gender-scoped**, from the existing `profile.photoBlurDefault`
 * setting (U15) — never a coded default per gender, and never an `if`.
 */
export const PHOTO_VISIBILITIES = ['blurred_until_match', 'visible'] as const;

export const PhotoVisibilitySchema = z.enum(PHOTO_VISIBILITIES);

export type PhotoVisibility = (typeof PHOTO_VISIBILITIES)[number];

const SET: ReadonlySet<string> = new Set<string>(PHOTO_VISIBILITIES);

/** Narrows a plain string — what a stored column goes through on read. */
export function isPhotoVisibility(value: string): value is PhotoVisibility {
  return SET.has(value);
}
